import styled from 'styled-components';
export const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  background: #f3f2f1;
  padding: 0 32px;
`;
export default {
  PageLayout
};